<template>
  <v-dialog :id="id+'-modal'" persistent lazy max-width="1000" :overlay="true" v-model="showModal">
    <v-card color="white" class="black--text"  >
      <v-toolbar tabs>
        <v-toolbar-title id="title">{{ name }}</v-toolbar-title>
      </v-toolbar>
      <br>
      <!-- Variable part of the modal injected here -->
      <slot name="modalContent"></slot>
      <v-toolbar tabs>
        <v-spacer></v-spacer>
        <v-btn color="black darken-1" flat @click="close">Close</v-btn>
      </v-toolbar>
    </v-card>
  </v-dialog>
</template>

<script>
import {EventBus} from '@/event-bus.js'
export default {
  props: {
    id: String,
    name: String,
    showModal: Boolean
  },
  methods: {
    close() {
      document.getElementsByClassName('v-dialog v-dialog--active')[0].scrollTop = 0;
      this.$emit('hide-modal')
    }
  },
  mounted: function () {
    EventBus.$on('destroy-modal-'+this.id, mod => {
      EventBus.$off('show-modal-'+this.moduleId);
      EventBus.$off('update-module-'+this.moduleId);
      EventBus.$off('destroy-modal-'+this.moduleId);
      if(this.$el.parentNode)
        this.$el.parentNode.removeChild(this.$el);
      this.$destroy();
    });
  }
}
</script>

<style scoped>
 #title {
    justify-content: flex-start !important;
    max-width: 1600px;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Workspace/Methods/ModalTemplate.vue